import * as React from "react";
import { Typography, Box, Grid, Stack } from "@mui/material";
import SpeedIcon from "@mui/icons-material/Speed";
import TouchAppIcon from "@mui/icons-material/TouchApp";
import ParkIcon from "@mui/icons-material/Park";
import { useNavigate } from "react-router-dom";
import ReactGA from "react-ga4";
import { MarketingPage, MarketingButton, MarketingCard } from "../../app/components/marketing";
import {
  marketingColors,
  marketingFonts,
  sectionLabelSx,
  sectionTitleSx,
  featureCardSx,
} from "../../app/components/tickitMarketingTheme";

const values = [
  { icon: <SpeedIcon sx={{ fontSize: 40, color: marketingColors.p700 }} />, title: "Speed & efficiency", body: "Barcode-first ticketing that keeps lines moving and organizers in control." },
  { icon: <TouchAppIcon sx={{ fontSize: 40, color: marketingColors.p700 }} />, title: "Convenience", body: "Guests buy online, receive tickets instantly, and scan at the door." },
  { icon: <ParkIcon sx={{ fontSize: 40, color: marketingColors.p700 }} />, title: "Less waste", body: "Digital tickets replace paper — better for guests and the planet." },
];

export const About = () => {
  const navigate = useNavigate();

  React.useEffect(() => {
    ReactGA.send({ hitType: "pageview", page: "/about", title: "About" });
  }, []);

  return (
    <MarketingPage maxWidth="lg">
      <Box sx={{ textAlign: "center", mb: 5 }}>
        <Typography sx={sectionLabelSx}>About Tickit</Typography>
        <Typography variant="h2" sx={{ ...sectionTitleSx, fontSize: { xs: "2rem", md: "2.5rem" } }}>
          Ticketing built for modern events
        </Typography>
      </Box>

      <Grid container spacing={2} sx={{ mb: 5 }}>
        {values.map((v) => (
          <Grid item xs={12} md={4} key={v.title}>
            <Box sx={{ ...featureCardSx, textAlign: "center", p: 3 }}>
              <Box sx={{ mb: 1.5 }}>{v.icon}</Box>
              <Typography sx={{ fontFamily: marketingFonts.display, fontWeight: 800, fontSize: "1.1rem", color: marketingColors.gray900, mb: 1 }}>
                {v.title}
              </Typography>
              <Typography sx={{ fontFamily: marketingFonts.body, fontSize: "0.9rem", color: marketingColors.gray500, lineHeight: 1.55 }}>
                {v.body}
              </Typography>
            </Box>
          </Grid>
        ))}
      </Grid>

      <MarketingCard title="Our story">
        <Stack spacing={2}>
          <Typography sx={{ fontFamily: marketingFonts.body, fontSize: "1rem", color: marketingColors.gray600, lineHeight: 1.7 }}>
            Tickit is an online ticketing and invitations platform for weddings, corporate nights, and ticketed experiences across MENA. We digitize the full journey — publish, sell, invite, and check in — with QR validation at the door.
          </Typography>
          <Typography sx={{ fontFamily: marketingFonts.body, fontSize: "1rem", color: marketingColors.gray600, lineHeight: 1.7 }}>
            Organizers get real-time visibility into sales and RSVPs; guests get a smooth purchase and arrival experience without paper tickets or long queues.
          </Typography>
        </Stack>
      </MarketingCard>

      <Box sx={{ display: "flex", justifyContent: "center", mt: 4 }}>
        <MarketingButton onClick={() => navigate("/events")}>Browse events</MarketingButton>
      </Box>
    </MarketingPage>
  );
};

export default About;
